import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/AlarmFill.tsx
const AlarmFillIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M15.999 6.072a8 8 0 1 1-11.995 7.213L3.999 13l.005-.285a8 8 0 0 1 11.995-6.643Zm-4 2.928a1 1 0 0 0-1 1v3l.007.117a1 1 0 0 0 .993.883h2l.117-.007a1 1 0 0 0 .883-.993l-.007-.117a1 1 0 0 0-.993-.883h-1v-2l-.007-.117A1 1 0 0 0 11.999 9Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M6.41 3.191a1 1 0 0 1 1.274 1.54l-.097.08-2.75 2a1 1 0 0 1-1.273-1.54l.097-.08 2.75-2ZM16.19 3.412a1 1 0 0 1 1.29-.288l.107.067 2.75 2a1 1 0 0 1-1.07 1.685l-.106-.067-2.75-2a1 1 0 0 1-.221-1.397Z",
		fill: props.fill || "currentColor"
	})]
}));
//#endregion
export { AlarmFillIcon };
